import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import Fields from './Fields';

const DispatchForm = forwardRef(({delivery, onSave, onSaved}, ref) => {
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={delivery}
      type="delivery"
      fieldsComponent={props => <Fields {...props} />}
      onSave={({number}) => onSave(number)}
      onSaved={onSaved}
    />
  );
});

export default DispatchForm;
